var render, staticRenderFns
import script from "./subTableColumn.vue?vue&type=script&lang=js&"
export * from "./subTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/sub/subTableColumn.vue"
export default component.exports